// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const MigrationFormMetricTitle = styled.span`
  color: ${COLORS.GREY_80};
`;
